exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SearchField {\n  display: inline-block;\n  position: relative; }\n  .SearchField input {\n    font-size: 13px;\n    display: block;\n    width: 100%;\n    height: 42px;\n    box-sizing: border-box;\n    padding: 1em;\n    margin: 0;\n    border-radius: 6px;\n    border: 0;\n    background: white;\n    outline: none;\n    box-shadow: 0 0 0 1px #E2E5E7;\n    transition: box-shadow 0.25s;\n    text-indent: 18px; }\n  .SearchField input:focus {\n      box-shadow: 0 0 0 1px #3A66E5; }\n  .SearchField svg {\n    vertical-align: middle; }\n  .SearchField svg path {\n      fill: currentColor; }\n  .SearchField svg.input-icon-left {\n      position: absolute;\n      height: 100%;\n      left: 12px;\n      top: 0;\n      width: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"config":{"path":"/workspace/config/postcss.config.js"}}!./~/@uniiverse/library/components/search-field/styles.css
// module id = 1502
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16